export const session = (state: any) => state.session;
export const accessToken = (state: any) => state.accessToken;
export const loggedIn = (state: any) => state.session || state.accessToken;
export const user = (state: any) => {
  if (state.session && state.session.data && state.session.data.user) {
    return state.session.data.user;
  }

  return null;
};
export const anonymous = (state: any) => state.anonymous;
